import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefoneXX'
})
export class TelefoneXXPipe implements PipeTransform {

  transform(value: string): string {

    if (!value) return value;

    const telefoneSemCodArea = /^\d{4}-\d{4}$/;
    const telefoneComCodAreaFixo = /^\(\d{2}\) \d{4}-\d{4}$/;
    const telefoneComCodAreaCelular = /^\(\d{2}\) \d{1} \d{4}-\d{4}$/;

    if (telefoneSemCodArea.test(value)) {
      return `(XX) ${value}`;
    } else if (telefoneComCodAreaFixo.test(value)) {
      return value;
    } else if (telefoneComCodAreaCelular.test(value)) {
      return value;
    } else {
      const valorNumerico = value.replace(/\D/g, '');
      if (valorNumerico.length === 10) {
        return `(${valorNumerico.slice(0, 2)}) ${valorNumerico.slice(2, 6)}-${valorNumerico.slice(6)}`;
      } else if (valorNumerico.length === 11) {
        return `(${valorNumerico.slice(0, 2)}) ${valorNumerico.slice(2, 3)} ${valorNumerico.slice(3, 7)}-${valorNumerico.slice(7)}`;
      }
    }

    return value;
  }

}
